import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import Header from 'components/ui/Header';

const ExporterHeader = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Header>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <button onClick={history.goBack} className="btn btn-icon text-white">
              <FiArrowLeft size={24} />
            </button>
          </div>
          <div>
            <h2 className="m-0 p-0 fw-lighter">{t('exporter.title')}</h2>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default ExporterHeader;
